import type { Tagged } from "@-/com.npmjs.type-fest";
import { createGate } from "@-/dev.improve.haniverse.lib.gate";
import type { PronunciationHint } from "@-/dev.improve.haniverse.lib.morpheme.grapheme.pinyin.hint";
import { useDrillPagePronunciationHint } from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._lib.pronunciation-hint";

export type DrillPagePronunciationHintGate = Tagged<
  { hint: PronunciationHint },
  "DrillPagePronunciationHintGate"
>;

/**
 * Whether a pronunciation review shows `DrillPagePronunciationHint` for the drilled reading
 * `pinyin`. `null` is the designed hidden state: the character has no hint for that reading.
 */
export function useDrillPagePronunciationHintGate(
  pinyin: string,
): DrillPagePronunciationHintGate | null {
  const { pronunciationHint } = useDrillPagePronunciationHint(pinyin);
  return pronunciationHint === null
    ? null
    : createGate<DrillPagePronunciationHintGate>({ hint: pronunciationHint });
}
